// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Asset } from './asset';
import { Counterparty } from './counterparty';
import { Dividend } from './dividend';
import { Entry } from './entry';
import { Liability } from './liability';
import { TaxCode } from './tax-code';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SubEntry extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  contextId!: number;
  entryDate!: Date;
  entryId!: number;
  subEntryId!: number;
  accountAccountId!: number;
  adminTypeId!: number;
  assetId?: number;
  assetPrice?: number;
  assetQuantity?: number;
  auditVersion!: number;
  bankedDate?: Date;
  basid?: number;
  contraAccountAccountId?: number;
  contributionId?: number;
  counterpartyId?: number;
  createdBy!: string;
  createdDate!: Date;
  creditorDividendId?: number;
  creditorId?: number;
  direction!: number;
  employeeId?: number;
  entryType!: number;
  fxnet!: number;
  fxtax!: number;
  fxtotal!: number;
  isBatchPosting?: boolean;
  isHeader!: boolean;
  isReconciled?: boolean;
  isSplit!: boolean;
  isTaxSubEntry!: boolean;
  liabilityId?: number;
  memo?: string;
  net!: number;
  payee?: string;
  paymentType?: number;
  reconciliationId?: number;
  reference?: string;
  reference1?: string;
  reference2?: string;
  reference3?: string;
  reference4?: string;
  reference5?: string;
  reportableTotal!: number;
  shareHolderId?: number;
  shareholderDividendId?: number;
  sweepId!: number;
  tax!: number;
  taxCodeId?: number;
  total!: number;
  ts!: string;
  uid?: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountAccount!: Account;
  asset!: Asset;
  contraAccountAccount!: Account;
  counterparty!: Counterparty;
  creditorDividend!: Dividend;
  entry!: Entry;
  liability!: Liability;
  taxCode!: TaxCode;
}

